import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { urlFor, client } from "client";
import AppWrap from "wrapper/AppWrap";
import "./About.scss";
import MotionWrap from "wrapper/MotionWrap";
import { useTranslation } from "react-i18next";
const About = () => {
  const { t } = useTranslation();

  const [about, setAbout] = useState([]);

  useEffect(() => {
    const query = "*[_type =='about']";
    client.fetch(query).then((data) => {
      setAbout(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">
        {t("section.about.part1")}
        <span> {t("section.about.part2")}</span>
        <br />
        {t("section.about.part3")}
        <span> {t("section.about.part4")}</span>
      </h2>
      <div className="app__profiles">
        {about.map((about, i) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profiles-item"
            key={i}
          >
            <img src={urlFor(about.imageUrl)} alt={about.name} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.name}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
      <div className="app__profiles-link">
        <a href="/about-detail" target="_parent">
          <button type="button" className="btn-custom">
            More About Me
          </button>
        </a>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
